import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import { css } from 'aphrodite'

import style from '../style'

import color from '../../../utils/color'

const CATEGORY_LIST = ['financial', 'technical', 'other']
const STATUS_TYPE = ['open', 'resolved']
const PRIORITY_LIST = ['high', 'mid', 'low']

const SupportHeader = props => {
  if (!props.owner || !props.ticket) {
    return null
  }

  const userFullName = `${props.owner.firstName || ' '} ${props.owner
    .lastName || ' '}`
  const userHexColor = color.stringToHex(userFullName)
  const fontHexColor = color.contrastHex(userHexColor)

  return (
    <Col className={css(style.tickets.header)}>
      <Row>
        <Col xs='auto'>
          <RenderAvatar
            bgColor={userHexColor}
            textColor={fontHexColor}
            {...props.owner}
          />
        </Col>
        <Col>
          <Row>
            <Col xs='auto'>
              <Link
                to={`/dashboard/user/${props.owner.id}`}
                className={css(style.tickets.authorSpan)}
              >
                {userFullName}
              </Link>
            </Col>
            {!props.community
              ? null
              : [
                <Col key={0} xs='auto' style={{ padding: `0` }}>
                  <span>&middot;</span>
                </Col>,
                <Col key={1} xs='auto'>
                  <Link
                    to={`/dashboard/community/${props.community.id}`}
                    className={css(style.tickets.authorSpan)}
                    >
                    {props.community.name}
                  </Link>
                </Col>
              ]}
          </Row>
          <Row>
            <Col>
              <h3
                className={css(
                  style.headers.h3,
                  style.headers.noMargin,
                  style.tickets.h3
                )}
              >
                {props.ticket.title}
              </h3>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className={css(style.tickets.actionsRow)}>
        <Col xs='auto' className={css(style.tickets.actionsCol)}>
          <RenderSelect
            options={CATEGORY_LIST}
            value={props.ticket.category}
            onChange={props.onCategoryChange}
          />
        </Col>
        <Col xs='auto' className={css(style.tickets.actionsCol)}>
          <RenderSelect
            options={STATUS_TYPE}
            value={props.ticket.status}
            onChange={props.onStatusChange}
          />
        </Col>
        <Col xs='auto' className={css(style.tickets.actionsCol)}>
          <RenderSelect
            options={PRIORITY_LIST}
            value={props.ticket.priority}
            onChange={props.onPriorityChange}
          />
        </Col>
        {/* <Col xs='auto' className={css(style.tickets.actionsCol)}>
          <RenderSelect
            options={['Marcos Silva', 'Patryk Cieszkowski', 'Toan Nguyen']}
            value={props.ticket.status}
            onChange={props.onSelectChange}
          />
        </Col> */}
      </Row>
    </Col>
  )
}

const RenderSelect = props => {
  return (
    <select
      value={props.value}
      className={css(style.selector.select)}
      onChange={props.onChange}
    >
      {props.options.map((item, index) => (
        <option value={index} key={index}>
          {item}
        </option>
      ))}
    </select>
  )
}

const RenderAvatar = props => {
  return (
    <div
      className={`d-flex align-items-center justify-content-around ${css(
        style.author.avatarBox
      )}`}
      style={{ backgroundColor: props.bgColor }}
    >
      <span
        className={css(style.author.avatarSpan)}
        style={{ color: props.textColor }}
      >
        {`${(props.firstName || ' ')[0]}${(props.lastName || ' ')[0]}`}
      </span>
    </div>
  )
}

export default SupportHeader



// WEBPACK FOOTER //
// ./src/components/Support/partials/SupportHeader.js